import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: "psichologists-patients",
    component: () => import("@/layouts/PrincipalLayout.vue"),
    children: [
        {
            path: "",
            name: "patients-index",
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.clients',
                        isActive: true
                    }
                ]
            },
            component: () => import("../views/Index.vue"),
        },
        {
            path: "patient-psicologist/:id/:consultation_id/:room_name",
            name: "patient-psychology-consultation",
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'patients-index',
                        },
                        transKey: 'breadcrumbs.clients',
                        isActive: false,
                    },
                    {
                        transKey: 'breadcrumbs.clients-detail',
                        isActive: true
                    }
                ]
            },
            component: () =>
                import(
                    "../views/Patient.vue"
                ),
        },
        {
            path: "details/:id",
            name: "patient-details",
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'patients-index',
                        },
                        transKey: 'breadcrumbs.clients',
                        isActive: false,
                    },
                    {
                        transKey: 'breadcrumbs.clients-detail',
                        isActive: true
                    }
                ]
            },
            component: () =>
                import(
                    "../views/Detail.vue"
                ),
        },
        {
            path: "details/phq9/:id",
            name: "patient-details-phq9",
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'patients-index',
                        },
                        transKey: 'breadcrumbs.clients',
                        isActive: false,
                    },
                    {
                        transKey: 'breadcrumbs.clients-detail',
                        isActive: true
                    }
                ]
            },
            component: () =>
                import(
                    "../views/Scales/PHQ9.vue"
                ),
        },
        {
            path: "details/gad7/:id",
            name: "patient-details-gad7",
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'patients-index',
                        },
                        transKey: 'breadcrumbs.clients',
                        isActive: false,
                    },
                    {
                        transKey: 'breadcrumbs.clients-detail',
                        isActive: true
                    }
                ]
            },
            component: () =>
                import(
                    "../views/Scales/GAD7.vue"
                ),
        },
        {
            path: "details/proqol/:id",
            name: "patient-details-proqol",
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'patients-index',
                        },
                        transKey: 'breadcrumbs.clients',
                        isActive: false,
                    },
                    {
                        transKey: 'breadcrumbs.clients-detail',
                        isActive: true
                    }
                ]
            },
            component: () =>
                import(
                    "../views/Scales/ProQOL.vue"
                ),
        },
        {
            path: "scheduled-sessions/:room_name?",
            name: "scheduled-sessions",
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.scheduled-sessions',
                        isActive: true
                    }
                ]
            },
            component: () => import(
                "../views/ScheduledSessions.vue"
            ),
        },
        {
            path: "ended-sessions",
            name: "ended-sessions",
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.ended-sessions',
                        isActive: true
                    }
                ]
            },
            component: () => import(
                "../views/EndedSessions.vue"
            ),
        }
    ],
};
